function getCartErrorMessage(errorData) {
  if (!errorData) return 'לא ניתן להוסיף את המוצר לסל כרגע';

  if (typeof errorData === 'string') return errorData;

  return (
    errorData.description ||
    errorData.message ||
    errorData.status_message ||
    'לא ניתן להוסיף את המוצר לסל כרגע'
  );
}

function showProductCardError(triggerElement, message) {
  if (!triggerElement) return;

  const productCard =
    triggerElement.closest('.product-card-content') ||
    triggerElement.closest('product-card') ||
    triggerElement.closest('.product-card');

  if (!productCard) return;

  const errorMsgDiv = productCard.querySelector('.cartErrorMsg');

  if (!errorMsgDiv) return;

  errorMsgDiv.innerText = message;

  window.clearTimeout(errorMsgDiv._platinClearTimer);
  errorMsgDiv._platinClearTimer = window.setTimeout(function () {
    errorMsgDiv.innerText = '';
  }, 1800);
}

async function addItemToCartProduct(variantId) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  });

  let responseData = null;

  try {
    responseData = await response.json();
  } catch (error) {
    responseData = null;
  }

  if (!response.ok) {
    const error = new Error(getCartErrorMessage(responseData));
    error.status = response.status;
    error.data = responseData;
    throw error;
  }

  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));

  return responseData;
}

document.addEventListener('click', async function (e) {
  const sizeValElement = e.target.closest('.size-val');

  if (!sizeValElement) return;

  const sizeWrapper = sizeValElement.closest('.altli');

  if (
    sizeValElement.dataset.loading === 'true' ||
    sizeValElement.getAttribute('aria-disabled') === 'true' ||
    sizeValElement.hasAttribute('disabled') ||
    (sizeWrapper && (
      sizeWrapper.getAttribute('disabled') === 'disabled' ||
      sizeWrapper.classList.contains('disabled') ||
      sizeWrapper.getAttribute('aria-disabled') === 'true'
    ))
  ) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  const variantId = sizeValElement.getAttribute('value') || sizeValElement.dataset.variantId;

  if (!variantId) {
    console.warn('Variant ID not found on the selected size-val element.');
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const originalContent = sizeValElement.innerHTML;

  sizeValElement.dataset.loading = 'true';
  sizeValElement.setAttribute('aria-busy', 'true');
  sizeValElement.innerHTML = '<div class="loader-layout"></div>';

  try {
    await addItemToCartProduct(variantId);
  } catch (error) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
      bubbles: true,
      detail: {
        error: error.message
      }
    }));

    showProductCardError(sizeValElement, error.message);
  } finally {
    window.setTimeout(function () {
      sizeValElement.innerHTML = originalContent;
      sizeValElement.dataset.loading = 'false';
      sizeValElement.removeAttribute('aria-busy');
    }, 350);
  }
});